<div class="auth-main">
    <div class="auth-main__content">
        <img
            class="auth-main__mobile-logo"
            src="./assets/icons/auth/brand-logo.svg"
            alt="Логотип"
        />
        <div class="auth-main__title">
            <span>{{ AuthFormTitle }}</span>
        </div>
        <p class="auth-main__subtitle">Восстановление пароля</p>
        <form
            (ngSubmit)="onSubmitPass()"
            [formGroup]="formNewPass"
            class="form"
            (keydown.enter)="focusNextInput($event)"
        >
            <label for="password">Придумайте пароль *</label>
            <div class="form__field">
                <input
                    id="password"
                    name="new-password"
                    [type]="hidePassword ? 'password' : 'text'"
                    formControlName="password"
                    autocomplete="new-password"
                    (input)="checkInput($event)"
                    #InputBlockPass
                    [class.invalid-input]="
                        formNewPass.get('password')?.touched &&
                        (formNewPass.get('password')?.invalid ||
                            formNewPass.hasError('passwordMismatch'))
                    "
                />
                <img
                    *ngIf="hidePassword"
                    src="./assets/icons/auth/show-password.svg"
                    alt="Показать пароль"
                    (click)="hidePassword = !hidePassword"
                />
                <img
                    *ngIf="!hidePassword"
                    src="./assets/icons/auth/hide-password.svg"
                    alt="Скрыть пароль"
                    (click)="hidePassword = !hidePassword"
                />
            </div>
            <label for="passwordRepeat">Повторите пароль *</label>
            <div class="form__field">
                <input
                    id="passwordRepeat"
                    name="new-password-confirmation"
                    [type]="hidePasswordRep ? 'password' : 'text'"
                    formControlName="passwordRepeat"
                    autocomplete="new-password"
                    (input)="checkInput($event)"
                    #InputBlockPassRep
                    [class.invalid-input]="
                        formNewPass.get('passwordRepeat')?.dirty &&
                        (formNewPass.get('passwordRepeat')?.invalid ||
                            formNewPass.hasError('passwordMismatch'))
                    "
                />
                <img
                    *ngIf="hidePasswordRep"
                    src="./assets/icons/auth/show-password.svg"
                    alt="Показать пароль"
                    (click)="hidePasswordRep = !hidePasswordRep"
                />
                <img
                    *ngIf="!hidePasswordRep"
                    src="./assets/icons/auth/hide-password.svg"
                    alt="Скрыть пароль"
                    (click)="hidePasswordRep = !hidePasswordRep"
                />
            </div>
            <div class="error-message" *ngIf="errorMessage">
                {{ errorMessage }}
            </div>
            <button
                mat-raised-button
                type="submit"
                [disabled]="formNewPass.invalid"
                class="form__submit"
            >
                <ng-container>Изменить пароль</ng-container>
                <ng-container>
                    <div class="form__submit-loader"></div>
                </ng-container>
            </button>
        </form>
        <div class="content-bottom">
            <div class="auth-main__register-hint" *ngIf="AccessReg">
                Впервые в личном кабинете?
            </div>
            <div
                class="go-to-button"
                (click)="goToRegistration()"
                *ngIf="AccessReg"
            >
                Регистрация
            </div>
        </div>
    </div>
    <div class="auth-main__img">
        <img class="img-logo" src="./assets/icons/auth/brand-logo.svg" alt="" />
        <img
            class="img-doctor"
            src="./assets/icons/auth/recovery-illustration.svg"
            alt=""
        />
    </div>
</div>
